<template>
  <div id="card" class="m-card">
    <div class="card">
      <p v-if="gogo">
        您当前没有任何卡劵！
        <a @click="gogogo">前往购买?</a>
      </p>
      <ul>
        <li v-for="(i, index) in payzklist" :key="index">
          <img draggable="false" :src="i.img" alt />
          <div class="jihuo">
            <div class="jihuoa"></div>
            <a class="jihuoo" v-show="i.status == 0" @click="jihuozk(i)">
              <!-- @click="jihuozk(i)" -->
              立即激活
            </a>
            <div class="zzshiyong" v-show="i.status == 1">
              <p>正在使用</p>
              <span
                >截止时间：{{
                  i.end_at
                    .split("T")
                    .join(" ")
                    .split("+")
                    .shift()
                }}</span
              >
            </div>
            <div class="yshiyong" v-show="i.status == 2">已使用</div>
          </div>
          <!-- <a  style="position: absolute;top:125px;right:10px" v-show="i.status==0?VIP=true:VIP=false" v-if="i.title=='周卡'?false:true">
                            <img src="../../static/images/icon/vipwenhao.png" alt="" @mouseenter.stop="vipenter()" >
                            <span style="
                            display:block;
                            width:300px;
                            padding:20px;
                            font-size:16px;
                            line-height:30px;
                            background:#fff;
                            position: absolute;
                            top:-350px;
                            left:-250px;
                            z-index:1;
                            border-radius: 10px;
                            box-shadow: #000 0px 0px 10px
                            " v-show="vipshuoming"  @mouseleave.stop="vipleave">
                            <i style="display:block;margin-bottom:10px;font-size:18px">活动规则：</i>
                            1、每个用户在活动期间登录客户端即可立即激活使用，或者可到海星云官网【www.haixingcloud.com】的【个人中心】—【我的卡包】中激活畅享卡即可立即登录客户端使用，该卡激活起70分钟后作废，仅限当天有效。<br>
                            2、海星云会每天0点准时将新的畅享卡打进每个账号中。<br>
                            <br>
                            <i style="display:block;margin-bottom:10px;font-size:18px">注意事项：</i>
                            1、畅享卡激活后需立即使用，激活起70分钟后该卡作废。<br>
                            2、可自主选择体验时间，仅当日有效。<br>
                            3、用户需更新至最新版的客户端，pc客户端需在v2.1.11-3及其以上版本，安卓客户端需在v2.1.4-1及其以上版本。<br>
                            4、畅享卡结束前会有提示，若选择不下机，则直接消耗账户里的海星点，用户可根据自身情况安排。<br>
                            5、畅享卡不可连续使用，需下机重启客户端或者下机后前往官网激活。
                            </span>
          </a>-->

          <a
            style="position: absolute;top:125px;right:10px"
            v-show="i.status == 0 ? (VIP = true) : (VIP = false)"
            v-if="i.prono == '002' ? false : true"
            @click="gift_card(i.id)"
          >
            <img
              draggable="false"
              src="../../static/images/icon/card.png"
              alt
            />
          </a>
        </li>
      </ul>
      <!-- <span style="font-size:16px;line-height:40px">此卡仅限当天有效</span> -->
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

      vipshuoming: false,
      gogo: false,
      jihuo: false,
      zzshiyong: false,
      yshiyong: true,
      s: 1,
      payzklist: [],
      zhouka: ''
    }
  },
  methods: {
    vipenter () {
      this.vipshuoming = true
    },
    vipleave () {
      this.vipshuoming = false
    },
    jihuozk (i) {
      this.$confirm('此操作将激活本卡劵, 是否继续?', '提示', {
        confirmButtonText: '确定激活',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.http.jhzhouka(i.id).then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: '激活成功！',
                type: 'success'
              })
              this.$router.push({
                path: './Center',
                query: {
                  route: 1
                }
              })
              this.$router.go(0)
            } else if (res.data.code == 400) {
              this.$message.error(res.data.message)
            } else if (res.data.code == 500) {
              this.$message.error(res.data.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消激活'
          })
        })
    },

    gift_card (id) {
      this.$router.push({ path: './gift_card', query: { card: id } })
    },
    gogogo () {
      this.$router.push({ path: './Rechargeing', query: { card: 1 } })
    }
  },
  mounted () {
    this.http.payzhouk().then(res => {
      this.payzklist = res.data.data.timecard_list
      // console.log(this.payzklist)
      if (this.payzklist == '') {
        this.gogo = true
      } else {
        this.gogo = false
      }
    })
  }
}
</script>
<style  lang="scss">
.m-card {
  background: rgba(156, 165, 236, 0.1);

  .card {
    ul {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      li {
        margin: 6px;
      }
    }
  }

  .card {
    // border: 1px solid #fff;
    // border-radius: 10px;
    padding: 30px;
    min-height: 600px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
  }
  .card > p {
    text-align: center;
    font-size: 30px;
    line-height: 100px;
  }
  .card > p a {
    font-size: 32px;
    color: red;
  }
  .card > p a:hover {
    text-decoration: underline;
  }

  .card ul li {
    width: 259px;
    height: 168px;
    position: relative;
  }
  .card ul li > img {
    width: 100%;
    height: 100%;
  }
  .card ul li .jihuo {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .card ul li .jihuo .jihuoa {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 15px;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.5;
  }
  .card ul li .jihuo .jihuoo {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -20px;
    margin-left: -60px;
    width: 120px;
    height: 40px;
    border-radius: 20px;
    background: #ff5244;
    text-align: center;
    line-height: 40px;
    color: #fff;
    font-size: 20px;
  }
  .card ul li .jihuo .zzshiyong {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .card ul li .jihuo .zzshiyong p {
    width: 100%;
    font-size: 24px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    line-height: 50px;
    margin-top: 40px;
  }
  .card ul li .jihuo .zzshiyong span {
    display: block;
    width: 100%;
    text-align: center;
    font-size: 16px;
    color: #fff;
  }
  .card ul li .jihuo .yshiyong {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    line-height: 168px;

    font-size: 24px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/card.vue